/*!
 * Inspiration from
 * modernizr v3.6.0
 * Build https://modernizr.com/download?-jpeg2000-jpegxr-video-webp-dontmin
 */

// export function GetOptimalVideoFormat(){
//     var elem = document.createElement('video');
//     var bool = false;

//     // IE9 Running on Windows Server SKU can cause an exception to be thrown, bug #224
//     try {
//         bool = !!elem.canPlayType
//         if (bool) {
//             bool = new Boolean(bool);
//             bool.ogg = elem.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, '');
//             // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
//             bool.h264 = elem.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '');
//             bool.webm = elem.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, '');
//             bool.vp9 = elem.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, '');
//             bool.hls = elem.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, '');
//         }
//     } catch (e) {}

//     return bool;
// }

var webP = new Promise((resolve)=>{
    // WebP test
    var image = new Image();
    image.onload = image.onerror = (event : any)=> resolve(event && event.type === 'load' ? image.width == 1 : false);
    image.src = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";    
})

var jpegXR = new Promise((resolve)=>{
    // Jpeg XR
    var image = new Image();
    image.onload = image.onerror = ()=>resolve(image.width == 1);
    image.src = 'data:image/vnd.ms-photo;base64,SUm8AQgAAAAFAAG8AQAQAAAASgAAAIC8BAABAAAAAQAAAIG8BAABAAAAAQAAAMC8BAABAAAAWgAAAMG8BAABAAAAHwAAAAAAAAAkw91vA07+S7GFPXd2jckNV01QSE9UTwAZAYBxAAAAABP/gAAEb/8AAQAAAQAAAA==';
});

var jpeg2000 = new Promise((resolve)=>{
    // Jpeg 2000
    var image = new Image();
    image.onload = image.onerror = ()=>resolve(image.width == 1);
    image.src = 'data:image/jp2;base64,/0//UQAyAAAAAAABAAAAAgAAAAAAAAAAAAAABAAAAAQAAAAAAAAAAAAEBwEBBwEBBwEBBwEB/1IADAAAAAEAAAQEAAH/XAAEQED/ZAAlAAFDcmVhdGVkIGJ5IE9wZW5KUEVHIHZlcnNpb24gMi4wLjD/kAAKAAAAAABYAAH/UwAJAQAABAQAAf9dAAUBQED/UwAJAgAABAQAAf9dAAUCQED/UwAJAwAABAQAAf9dAAUDQED/k8+kEAGvz6QQAa/PpBABr994EAk//9k=';
});
var result = new Promise<string>((resolve)=>{
    Promise.all([webP, jpegXR, jpeg2000]).then(function(values) {
        if(process.env.NODE_ENV != "production")
        {
            resolve("jpeg");
            return;
        }
        // console.log(values);
        // resolve(values[0] ? "WebP" :
        //     values[1] ? "JpegXR" : 
        //     values[2] ? "Jpeg2000" : "Jpeg");
        resolve(values[0] ? "webp" : "jpeg");
            // values[1] ? "JpegXR" : 
            //values[2] ? "jp2" : "jpeg");
      });
})
export async function GetOptimalImageFormat() : Promise<string>{
    return  result;
}